import { render, staticRenderFns } from "./ConnectWallet.vue?vue&type=template&id=016cafcc&scoped=true"
import script from "./ConnectWallet.vue?vue&type=script&lang=js"
export * from "./ConnectWallet.vue?vue&type=script&lang=js"
import style0 from "./ConnectWallet.vue?vue&type=style&index=0&id=016cafcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016cafcc",
  null
  
)

export default component.exports